import Vue from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import ChatParticipant from '@/models-ts/chat/ChatParticipant'
import { RootState } from '@/store'

export default Vue.extend({
  computed: {
    ...mapState<RootState>({
      userId: (state: RootState) => state.user?.id,
    }),
    ...mapGetters({
      room: 'chatNew/getOpenedRoom',
    }),
  },
  methods: {
    ...mapActions({
      openModal: 'ui/openModal',
    }),
    reportUser() {
      const toUser = this.room.participants.find((user: ChatParticipant) => +user.userId !== this.userId)

      this.openModal({
        component: 'lx-lazy-modal',
        props: {
          factory: import(/* webpackChunkName: "job-modals" */ '@/modals/ReportUser/ReportUser.vue'),
          props: {
            toUserId: toUser.userId,
            toUserName: toUser.name,
          },
        },
      })
    },
  },
})
